import React, {Component} from 'react';
import {UncontrolledTooltip} from "reactstrap";
import {request} from "../../util/APIUtils";
import {deepCopyObject, showAxiosError, trimObject} from "../../util/Helpers";
import Alert from "react-s-alert";
import {validateComponent, validateField} from "../../common/validation";
import {API_BASE_URL} from "../../constants";
import './Payment.css';
import {input} from "antd";
import Select from "../../local_node_modules/react-select"
import LoadingIndicator from "../../common/LoadingIndicator";

class TransactionTypeForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
            mode: 'create',
            page: 0,
            size: 10,
            manual: false,
            loading: false,
            fieldsDisabled: false,
            typeSelectionDisabled: false,
            isItemLoading: false,
            transactionType: {
                id: null,
                name: null,
                transactionDirectionType: null
            }
        };

        this.validateClass = this.validateClass.bind(this);
        this.validateComponent = this.validateComponent.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.saveTransactionType = this.saveTransactionType.bind(this);
        this.cancelProcess = this.cancelProcess.bind(this);
    }

    componentDidMount() {
        console.log("this.props.selectedTransactionType", this.props.selectedTransactionType);
        if (this.props.selectedTransactionType) {
            let typeSelectionDisabled = true;
            let selectedTransactionType = deepCopyObject(this.props.selectedTransactionType);
            let mod = deepCopyObject(this.props.mode);
            this.setState({mode: mod, transactionType: selectedTransactionType, typeSelectionDisabled});
        }
    }

    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let value = e.target.value;
        let result = validateField(rule, boundary, value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    validateComponent() {
        let result = validateComponent(this);
        this.setState({
            error: result.error
        });
        return result
    }

    onChange(e) {
        this.setState({
            transactionType: {
                ...this.state.transactionType,
                [e.target.name]: e.target.value
            }
        })
    }

    onSelectChange(name, value) {
        let transactionType = this.state.transactionType;
        if (value === null) {
            transactionType[name] = null
        } else {
            transactionType[name] = value.value;
        }
        this.setState({transactionType});

    }


    saveTransactionType() {
        let self = this;
        let params;
        let data;
        let message;
        let transactionType = deepCopyObject(this.state.transactionType);
        let validity = this.validateComponent();

        if (validity.valid) {
            self.setState({isLoading: true});
            transactionType = trimObject(transactionType);
            data = transactionType;
            if (transactionType.id === null) {
                message = 'Gelir-Gider Tipi Başarıyla Kaydedildi.'
                params = {
                    url: API_BASE_URL + "/transaction-type",
                    data: data,
                    method: 'post'
                };
            } else {
                message = 'Gelir-Gider Tipi Başarıyla Güncellendi.'
                params = {
                    url: API_BASE_URL + "/transaction-type",
                    data: data,
                    method: 'patch'
                };
            }
            request(params).then(() => {
                Alert.success(
                    message, {
                        position: 'top-right',
                        effect: 'stackslide',
                        timeout: 5000
                    });
                self.setState({isLoading: false});
                this.cancelProcess();
                self.props.handleSearch();
            }).catch(function (error) {
                self.setState({isLoading: false});
                showAxiosError(error);
            });
        } else {
            let message = 'Hatalı veya eksik alanlar var!';
            Alert.error(message, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 5000
            });
        }
    }


    cancelProcess() {
        this.props.cancelProcess();
    }

    render() {

        const transactionDirectionTypes = [
            {value: 'INCOME', label: "GELİR"},
            {value: 'EXPENSE', label: "GİDER"},];

        return (
            <div className='transaction-type-form-container'>
                {
                    (this.state.isLoading) &&
                    <div className="loader">
                        <LoadingIndicator/>
                    </div>
                }
                <div className='card-header'>
                    <h4 className="card-title">{this.state.mode === 'create' ? 'Yeni Gelir-Gider Tipi Oluştur' : 'Gelir-Gider Tipi Düzenle'}</h4>
                </div>
                <div className="card-body" style={{marginTop:"10px"}}>
                    <div className="FormRenk col-sm-12">
                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Ad *</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('tName')}>
                                    <input className="form-control"
                                           type="text"
                                           name="name"
                                           id="tName"
                                           data-vlength="5,255"
                                           onBlur={this.validateField}
                                           ref="tName"
                                           value={this.state.transactionType.name}
                                           onChange={(e) => this.onChange(e)}
                                    />
                                    {this.validateMessage('tName') !== "" &&
                                    <UncontrolledTooltip placement="right" target="tName" delay={0}>
                                        {this.validateMessage("tName")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>

                        <div className='col-sm-12 row'>
                            <div className="col-sm-3">
                                <label>Gelir/Gider*</label>
                            </div>
                            <div className="col-sm-9">
                                <div className={"form-group" + this.validateClass('TtransactionDirectionType')}>
                                    <Select
                                        className="basic-single"
                                        classNamePrefix="select"
                                        placeholder="Seçiniz."
                                        name="transactionDirectionType"
                                        style={{width: 250}}
                                        inputProps={{'vdata': "required"}}
                                        ref="TtransactionDirectionType"
                                        id="TtransactionDirectionType"
                                        disabled={this.state.typeSelectionDisabled}
                                        options={transactionDirectionTypes}
                                        onChange={(value) => this.onSelectChange("transactionDirectionType", value)}
                                        value={this.state.transactionType.transactionDirectionType}
                                    />
                                    {this.validateMessage('TtransactionDirectionType') !== "" &&
                                    <UncontrolledTooltip placement="right" target="TtransactionDirectionType" delay={0}>
                                        {this.validateMessage("TtransactionDirectionType")}
                                    </UncontrolledTooltip>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* CARD FOOTER */}
                <div className="modal-footer">
                    <div className='col-sm-12 row' id="deleteModal">
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{background: '#9e9e9e', padding: '10px 54px 10px 23px', width:"150px"}}
                                    rel="tooltip" className="TekBtn vazgec "
                                    onClick={this.cancelProcess}>
                                İptal
                            </button>
                        </div>
                        <div className="col-sm-8"/>
                        <div className='col-sm-2'>
                            <button type="button" data-toggle="tooltip" data-placement="bottom"
                                    style={{
                                        background: 'linear-gradient(rgba(159, 208, 55, 0.6), #9fd037)',
                                        float: 'right', padding: '10px 54px 10px 23px', width:"150px"
                                    }}
                                    rel="tooltip" className="TekBtn kaydet"
                                    disabled={this.state.fieldsDisabled || this.state.isLoading}
                                    onClick={() => this.saveTransactionType()}>{this.state.mode === 'create' ? 'Kaydet' : 'Güncelle'}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TransactionTypeForm;


// WEBPACK FOOTER //
// ./src/page/financial/TransactionTypeForm.js